module.exports = __webpack_public_path__ + "img/Success_Box@2x.b8c50e9f.png";